import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import { CreateServiceButtonIcon, MyServicePageButtonIcon } from "../../assets/icons/go-service-icons";

import TrendingServices from "./TrendingServices";
import TopServiceProviders from "./TopServiceProviders";
import { getCreateServiceRoute, getEntityProfileRoute } from "../../../../routers/routeUtils";
import { useProfileData } from "../../../../hooks/useProfileData";

const OverviewServices = () => {
  const { t } = useTranslation("goService", { keyPrefix: "goService" });

  const navigate = useNavigate();
  const {
    data: { entityId },
    isLoading: isEntityIdLoading,
  } = useProfileData();

  const handleCreateService = () => {
    navigate(getCreateServiceRoute());
  };

  const handleMyServices = () => {
    if (!entityId) return;
    navigate(getEntityProfileRoute(entityId, "goService"));
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.titleContainerWrapper}>
        <Box sx={styles.titleContainer}>
          <Typography sx={styles.title}>{t("title")}</Typography>
          <Typography sx={styles.description}>{t("howCanGoalngoHelpYouToday")}</Typography>
        </Box>
        <Box sx={styles.buttonsContainer}>
          <Button
            variant="outlined-sm"
            startIcon={<MyServicePageButtonIcon />}
            onClick={handleMyServices}
            disabled={isEntityIdLoading}
          >
            {t("myServices")}
          </Button>
          <Button variant="primary-sm" startIcon={<CreateServiceButtonIcon />} onClick={handleCreateService}>
            {t("createService")}
          </Button>
        </Box>
      </Box>
      <TrendingServices />
      <TopServiceProviders />
    </Box>
  );
};

export default OverviewServices;

const styles = {
  container: {
    width: { xs: "100%", lg: "866px" },
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  titleContainerWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "30px",
  },
  description: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  buttonsContainer: { height: "fit-content", display: "flex", gap: "12px" },
};
